import {
    FullAudit,
    IsActiveFlag,
    ScheduleWeekday,
    UserModel,
    WorkScheduleUserModel,
} from '@/types';

export interface WorkScheduleModel extends IsActiveFlag, FullAudit {
    id: number;
    levelId: number;
    name: string;
    [ScheduleWeekday.MONDAY]: boolean;
    [ScheduleWeekday.TUESDAY]: boolean;
    [ScheduleWeekday.WEDNESDAY]: boolean;
    [ScheduleWeekday.THURSDAY]: boolean;
    [ScheduleWeekday.FRIDAY]: boolean;
    [ScheduleWeekday.SATURDAY]: boolean;
    [ScheduleWeekday.SUNDAY]: boolean;
    timeBegin: string;
    timeEnd: string;
    users?: UserModel[];
    workScheduleUsers?: WorkScheduleUserModel[];
}
